import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icon.d.ts').IconArrowLeft}
 */
const IconArrowLeft = () => {
    return (
        <svg
            aria-hidden='true'
            fill='none'
            height='32'
            viewBox='0 0 20 20'
            width='32'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M15.166 9.66536L6.12122 9.66537L10.4689 5.31766L9.99935 4.83203L4.83268 9.9987L9.99935 15.1654L10.4689 14.6797L6.12122 10.332L15.166 10.332L15.166 9.66536Z'
                fill='currentColor' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default IconArrowLeft;
